export enum CustomListFormMode {
    CREATE = 'CREATE',
    RENAME = 'RENAME',
}
